import React from 'react';
import { Tooltip, TooltipProps } from '@material-ui/core';
import { withStyles, Theme } from '@material-ui/core/styles';

const createStyledTooltip = (backgroundColor?: string) =>
  withStyles((theme: Theme) => {
    const bgColor = backgroundColor || theme.palette.common.black;
    return {
      tooltip: {
        backgroundColor: bgColor,
        color: theme.palette.getContrastText(bgColor),
        boxShadow: theme.shadows[1],
        fontSize: 12,
        borderRadius: 4,
        padding: '8px 12px',
        maxWidth: 300,
      },
      arrow: {
        color: bgColor,
      },
    };
  })(Tooltip);

interface AdvancedTooltipProps extends Omit<TooltipProps, 'title'> {
  title?: string | React.ReactNode;
  disabled?: boolean;
  backgroundColor?: string;
}

const AdvancedTooltip = ({
  title,
  disabled = false,
  backgroundColor,
  children,
  ...props
}: AdvancedTooltipProps) => {
  if (!title || disabled) {
    return <>{children}</>;
  }

  const StyledTooltip = createStyledTooltip(backgroundColor);

  return (
    <StyledTooltip
      title={title}
      arrow
      placement="top"
      enterDelay={500}
      leaveDelay={200}
      {...props}
    >
      <span style={{ display: 'inline-block', cursor: 'inherit' }}>
        {children}
      </span>
    </StyledTooltip>
  );
};

export default AdvancedTooltip;
